import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserLoginFormValidator from './views/UserLoginFormValidator';

export default class UserLoginNode extends NodeModule {
  start(options) {
    console.log('Starting User Login');
    const userLogin = new Form({el: options.el, formEl: '#loginForm', type: (opts) => new UserLoginFormValidator(opts)});
  }
}